import React, { useEffect, useState } from 'react';
import '../Assets/Css/AddTaskStatusModal.scss';
import Select from 'react-select';
import { customStyle } from './Style';
import { Modal, Spinner } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { SortableContainer, SortableElement, SortableHandle } from 'react-sortable-hoc';
import { arrayMoveImmutable } from 'array-move';
import { PiListDuotone } from "react-icons/pi";
import closeIcon from '../Assets/Images/Pop-Up/Close_button.svg'


const DragHandle = SortableHandle(() => (
    <span style={{ cursor: 'grab', marginRight: '10px' }}>
        <PiListDuotone />
    </span>
));

const SortableItem = SortableElement(({ item, index, handleUpdate, handleDelete, deleteLoading, isEdit, setLabelName, handleColorChange, colorValue, handleTextChange, labelName, updateId, handleAddUpdateTaskStatus, loading, handleCancelEdit }) => (
    <tr>
        <td>
            <DragHandle />
        </td>
        <td className="w-50">{isEdit && updateId === item.id
            ? <input
                type="text"
                id="labelName"
                value={labelName}
                onChange={(e) => setLabelName(e.target.value)}
                placeholder='Enter Task Status Name'
                className="popup-input"
            />
            : item?.name}</td>
        <td className="w-50">{isEdit && updateId === item.id
            ? <div className="form-group" style={{ position: 'relative' }}>
                <input
                    type="text"
                    className="input-css"
                    name="title"
                    placeholder="Color"
                    value={colorValue}
                    onChange={handleTextChange}
                />
                <input
                    type="color"
                    className="color-picker"
                    style={{
                        position: "absolute",
                        right: "1.7px",
                        top: "1.5px",
                        height: "36px",
                        width: "36px",
                        padding: "8px",
                        border: "none",
                        cursor: "pointer",
                        backgroundColor: "transparent",
                        backdropFilter: "blur(3px)",
                        background: "rgba(0, 0, 0, 0.09)",
                        borderRadius: "3px",
                    }}
                    onChange={handleColorChange}
                    value={colorValue}
                />
            </div>
            : (
                <div>
                    {item?.color_code}
                    <span
                        style={{
                            marginLeft: '10px',
                            backgroundColor: item?.color_code,
                            width: "10px",
                            height: "10px",
                            borderRadius: '50%',
                            display: "inline-block"
                        }}
                    ></span>
                </div>
            )
        }
        </td>
        {isEdit && updateId === item.id
            ? <td className="action-buttons d-flex justify-content-center" style={{ gap: "10px" }}>
                <button
                    onClick={handleAddUpdateTaskStatus}
                    className='update-btn'
                    disabled={loading}
                >
                    {loading ? <Spinner size="sm" /> : "Save"}
                </button>
                <button
                    onClick={handleCancelEdit}
                    className='cancel-btn'
                >
                    Cancel
                </button>
            </td>
            : <td className="action-buttons d-flex justify-content-center">
                <button onClick={() => handleUpdate(item?.id)} className='update-btn'>
                    {deleteLoading ? (<Spinner as="span" animation="border" role="status" aria-hidden="true" />) : "Update"}
                </button>
                <button onClick={() => handleDelete(item?.id)} className='delete-btn'>
                    {deleteLoading ? (<Spinner as="span" animation="border" role="status" aria-hidden="true" />) : "Delete"}
                </button>
            </td>
        }
    </tr >
));

const SortableList = SortableContainer(({ items, handleUpdate, handleDelete, deleteLoading, isEdit, setLabelName, handleColorChange, colorValue, handleTextChange, labelName, updateId, handleAddUpdateTaskStatus, loading, handleCancelEdit }) => {
    return (
        <tbody>
            {items?.length == 0 && (
                <tr>
                    <td colSpan="4" style={{ textAlign: 'center', padding: '10px' }}>
                        No Records.
                    </td>
                </tr>
            )}
            {items.map((item, index) => (
                <SortableItem
                    key={`item-${item.id}`}
                    index={index}
                    item={item}
                    handleUpdate={handleUpdate}
                    handleDelete={handleDelete}
                    deleteLoading={deleteLoading}
                    isEdit={isEdit}
                    setLabelName={setLabelName}
                    labelName={labelName}
                    handleColorChange={handleColorChange}
                    colorValue={colorValue}
                    handleTextChange={handleTextChange}
                    updateId={updateId}
                    handleAddUpdateTaskStatus={handleAddUpdateTaskStatus}
                    loading={loading}
                    handleCancelEdit={handleCancelEdit}

                />
            ))}
        </tbody>
    );
});

function AddTaskStatusModal({ isOpen, onClose, addTaskStatus,
    taskStatus,
    loading,
    deleteTaskStatus,
    deleteLoading,
    updateTaskStatus,
    taskStatusList,
    setTaskStatusList,
    data,
    addTaskStatusPayload,
    getTaskStatus }) {
    const [labelName, setLabelName] = useState('');
    const [colorValue, setColorValue] = useState("#ff0000");
    const [updateId, setUpdateId] = useState(null);
    const [activeTab, setActiveTab] = useState("all-status");
    const [isAdd, setIsAdd] = useState(false);
    const [isEdit, setIsEdit] = useState(false);

    const handleColorChange = (e) => {
        setColorValue(e.target.value);
    };

    const handleTextChange = (e) => {
        setColorValue(e.target.value);
    };

    const handleDelete = async (id) => {
        try {
            await deleteTaskStatus(id);
            setTaskStatusList(prev => prev?.filter(item => item?.id !== id));
        } catch (error) {
            console.log("Error deleting record: ", error)
        }
    };

    const handleUpdate = async (id) => {
        setIsAdd(false)
        setIsEdit(true)
        try {
            const filtered = taskStatus.find((item) => item.id === id);
            setColorValue(filtered?.color_code);
            setLabelName(filtered?.name);
            setUpdateId(id);
        } catch (error) {
            console.error("Error in setting updated value in input: ", error)
        }
    };

    const handleAddUpdateTaskStatus = async () => {
        try {
            if (!labelName || !colorValue) {
                toast.error("Please fill all the required fields");
                return;
            }
            let body = {
                name: labelName,
                color_code: colorValue
            }
            if (updateId) {
                await updateTaskStatus(updateId, body);
                setTaskStatusList(prev =>
                    prev.map(item =>
                        item.id === updateId ? { ...item, name: labelName, color_code: colorValue } : item
                    )
                );
            }
            else {
                if (data?.id) {
                    body.project_id = data?.id
                }
                await addTaskStatus(body);

                if (data?.id) {
                    if (typeof getTaskStatus === "function") {
                        await getTaskStatus();
                    }
                }
            }
        } catch (error) {
            console.error("Error in add/edit task status:", error);
        }
        finally {
            setLabelName('');
            setColorValue('#ff0000')
            setIsEdit(false)
            setIsAdd(false)
        }

    };

    useEffect(() => {
        if (addTaskStatusPayload) {
            setTaskStatusList(prev => [...prev, addTaskStatusPayload]);
        }
    }, [addTaskStatusPayload]);

    const handleAddTaskStatus = (id) => {
        const selected = taskStatus.find(item => item.id === id);
        if (!selected) return;

        setTaskStatusList(prev => {
            const exists = prev.find(item => item.id === id);
            if (!exists) {
                return [...prev, selected];
            }
            return prev;
        });
        toast.success("Task Status Added Successfully")
    }

    const handleCancelEdit = () => {
        setIsEdit(false);
        setUpdateId(null);
        setLabelName('');
        setIsAdd(false);
    };
    return (
        <>
            <Modal
                show={isOpen}
                onHide={onclose}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                className="custom-modal"
            >
                <div className="modal-content">
                    <div className="modal-header">
                        <h5>Task Status</h5>
                        <button className="close-btn" onClick={onClose}>
                            {<img src={closeIcon} alt="Close" />}
                        </button>
                    </div>
                    <div className="modal-body">
                        <div className="d-flex">
                            <button className={`model-tab-button ${activeTab === "all-status" ? "active" : ""}`} onClick={() => { setActiveTab("all-status") }}>All Status</button>
                            <button className={`model-tab-button ${activeTab === "selected-or-added-status" ? "active" : ""}`} onClick={() => { setActiveTab("selected-or-added-status") }}>Selected / Added Status</button>
                        </div>
                        <div style={{ marginTop: '16px' }}>
                            {activeTab === "all-status"
                                ? <table className="table">
                                    <thead>
                                        <tr>
                                            <th>Name</th>
                                            <th>Color Code</th>
                                            <th className='text-center'>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {taskStatus
                                            ?.slice()
                                            ?.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt))
                                            ?.map((item, index) => {
                                                return (
                                                    <tr key={item?.id}>
                                                        <td className="w-50">{item?.name}</td>
                                                        <td className="w-50">{item?.color_code}
                                                            <span style={{ marginLeft: '10px', backgroundColor: item?.color_code, width: "10px", height: "10px", borderRadius: '50%', display: "inline-block" }}></span>
                                                        </td>
                                                        <td className="action-buttons d-flex justify-content-center">
                                                            <button onClick={() => handleAddTaskStatus(item?.id)} className='update-btn'>{taskStatusList?.some(tasks => tasks.id === item?.id) ? "Added" : "Add"} </button>
                                                            <button onClick={() => handleDelete(item?.id)} className='delete-btn'>
                                                                {deleteLoading ? (<Spinner as="span" animation="border" role="status" aria-hidden="true" />) : "Delete"}</button>
                                                        </td>
                                                    </tr>
                                                )
                                            })}
                                        {taskStatus?.length == 0 && (
                                            <tr>
                                                <td colSpan="4" style={{ textAlign: 'center', padding: '10px' }}>
                                                    No Records.
                                                </td>
                                            </tr>
                                        )}
                                        {isAdd
                                            ?
                                            <tr>
                                                <td className="w-50">
                                                    <input
                                                        type="text"
                                                        id="labelName"
                                                        value={labelName}
                                                        onChange={(e) => setLabelName(e.target.value)}
                                                        placeholder='Enter Task Status Name'
                                                        className="popup-input"
                                                    />
                                                </td>
                                                <td className="w-50">
                                                    <div className="form-group" style={{ position: 'relative' }}>
                                                        <input
                                                            type="text"
                                                            className="input-css"
                                                            name="title"
                                                            placeholder="Color"
                                                            value={colorValue}
                                                            onChange={handleTextChange}
                                                        />
                                                        <input
                                                            type="color"
                                                            className="color-picker"
                                                            style={{
                                                                position: "absolute",
                                                                right: "1.7px",
                                                                top: "1.5px",
                                                                height: "36px",
                                                                width: "36px",
                                                                padding: "8px",
                                                                border: "none",
                                                                cursor: "pointer",
                                                                backgroundColor: "transparent",
                                                                backdropFilter: "blur(3px)",
                                                                background: "rgba(0, 0, 0, 0.09)",
                                                                borderRadius: "3px",
                                                            }}
                                                            onChange={handleColorChange}
                                                            value={colorValue}
                                                        />
                                                    </div>
                                                </td>
                                                <td className="action-buttons d-flex justify-content-center" style={{ gap: '10px' }}>
                                                    <button
                                                        onClick={handleAddUpdateTaskStatus}
                                                        className='update-btn'
                                                        disabled={loading}
                                                    >
                                                        {loading ? <Spinner size="sm" /> : "Save"}
                                                    </button>
                                                    <button
                                                        onClick={handleCancelEdit}
                                                        className='cancel-btn'
                                                    >
                                                        Cancel
                                                    </button>
                                                </td>
                                            </tr>
                                            : ""
                                        }
                                    </tbody>
                                </table>
                                : ""}
                            {activeTab === "selected-or-added-status"
                                ?
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th></th>
                                            <th>Name</th>
                                            <th>Color Code</th>
                                            <th className='text-center'>Action</th>
                                        </tr>
                                    </thead>
                                    <SortableList
                                        items={taskStatusList}
                                        onSortEnd={({ oldIndex, newIndex }) => {
                                            if (oldIndex !== newIndex) {
                                                setTaskStatusList(arrayMoveImmutable(taskStatusList, oldIndex, newIndex));
                                            }
                                        }}
                                        helperClass="sortable-helper"
                                        useDragHandle
                                        handleUpdate={handleUpdate}
                                        handleDelete={handleDelete}
                                        deleteLoading={deleteLoading}
                                        isEdit={isEdit}
                                        setLabelName={setLabelName}
                                        labelName={labelName}
                                        handleColorChange={handleColorChange}
                                        colorValue={colorValue}
                                        handleTextChange={handleTextChange}
                                        updateId={updateId}
                                        handleAddUpdateTaskStatus={handleAddUpdateTaskStatus}
                                        loading={loading}
                                        handleCancelEdit={handleCancelEdit}


                                    />
                                    {/* <tbody>
                                        {taskStatusList?.map((item, index) => {
                                            return (
                                                <tr key={item?.id}>
                                                    <td>{item?.id}</td>
                                                    <td>{item?.name}</td>
                                                    <td>{item?.color_code}
                                                        <span style={{ marginLeft: '10px', backgroundColor: item?.color_code, width: "10px", height: "10px", borderRadius: '50%', display: "inline-block" }}></span>
                                                    </td>
                                                    <td className="action-buttons">
                                                        <button onClick={() => handleUpdate(item?.id)} className='update-btn'>
                                                            {deleteLoading ? (<Spinner as="span" animation="border" role="status" aria-hidden="true" />) : "Update"}</button>
                                                        <button onClick={() => handleDelete(item?.id)} className='delete-btn'>
                                                            {deleteLoading ? (<Spinner as="span" animation="border" role="status" aria-hidden="true" />) : "Delete"}</button>
                                                    </td>
                                                </tr>
                                            )
                                        })}

                                    </tbody> */}
                                </table>
                                : ""}
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button
                            className="save-btn"
                            onClick={() => { setIsAdd(true); setActiveTab("all-status"); setIsEdit(false) }}
                            disabled={loading || isAdd}
                        >
                            Add New Task
                        </button>
                    </div>
                </div >
            </Modal >
        </>
    );
}

export default AddTaskStatusModal;